import React, { useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AppContext from "../../../../Context/AppContext";
import { requestAxios } from "../../../../util/util";
import "./ModalEnviarCorreo.css";

const ModalAdicion = ({ show, setShow, acreditadoInfo }) => {
  const [text, setText] = useState("");
  const [asunto, setAsunto] = useState("");
  const { checkUserSession, changeLoading } = useContext(AppContext);
  const infoUs = checkUserSession();

  async function sendEmail() {
    changeLoading(true);
    const objPost = {
      AcreditadoId: acreditadoInfo.AcreditadoId,
      Asunto: asunto,
      Body: text,
    };
    const { error, data } = await requestAxios({
      url: `Email/sendEmail`,
      method: "post",
      token: infoUs.bearer_token,
      data: objPost,
    });
    if (error === "") {
      changeLoading(false);
      if (data.StatusCode == 200 || data.StatusCode == 201) {
        const MySwal = withReactContent(Swal);
        await MySwal.fire({
          title: <strong>Correo enviado con éxito!</strong>,
          // html: <i>Saved success!</i>,
          icon: "success",
        });
        setShow(false)
      } else {
        const MySwal = withReactContent(Swal);
        await MySwal.fire({
          title: <strong>Error al enviar el correo!</strong>,
          // html: <i>Saved success!</i>,
          icon: "error",
        });
      }
    }
    changeLoading(false);
  }
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90wEnviarCorreos"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="">
          <h2>Enviar correo electrónico</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Para: <b>{acreditadoInfo.Email}</b>
        <br />
        <input
          placeholder="Asunto"
          onChange={(input) => setAsunto(input.target.value)}
          value={asunto}
        />
        <CKEditor
          className="txtEmail"
          editor={ClassicEditor}
          data={text}
          onChange={(event, editor) => {
            const data = editor.getData();
            setText(data);
          }}
        />
        <div className="btnCerrarModalUltimos7">
          <br />
          <button
            className="btnEnviarCorreo"
            onClick={() => {
              sendEmail();
            }}
          >
            Enviar
          </button>

          <button
            className="btnNuevaGestion"
            onClick={() => {
              setShow(false);
            }}
          >
            Cerrar
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAdicion;
